import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "../../validation-types/SchemaDefinition";

const buildLogoObjectKey = (
  key: string,
  isFavicon: boolean,
  isDarkModeLogo: boolean
): string => {
  if (isFavicon) {
    return `${key}-favicon`;
  }
  if (isDarkModeLogo) {
    return `${key}-logo-dark`;
  }
  return `${key}-logo`;
};

export const generateLogoGetUrl = (axios: IAxiosInstance) => {
  return async ({
    key,
    isFavicon = false,
    isDarkModeLogo = false,
  }: ISchema["#/definitions/IGenerateLogoGetUrlArgs"]) => {
    const response = await axios.noRetry.get<
      ISchema["#/definitions/IGenerateLogoGetUrlResponse"]
    >(`/generate-logo-get-url`, {
      params: {
        key: buildLogoObjectKey(key, isFavicon, isDarkModeLogo),
      },
    });
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
